<template>
  <share-popover
    :category="category"
    :context="context"
    :flashcard="flashcard"
    :popover-title="title"
    :popover-description="text"
    :share-messsage="message"
    share-text="SHARE"
    :url="url"
  />
</template>

<script>
import SharePopover from '@components/share/sharePopover.vue';

export default {
  components: { SharePopover },
  props: {
    category: {
      type: Object,
    },
    context: {
      type: String,
    },
    flashcard: {
      type: Object,
    },
  },
  computed: {
    config() {
      return this.$store.getters['productVars/get']['flashcardShareMessage']?.parsedValue;
    },
    message() {
      return this.config?.message_text;
    },
    title() {
      return this.config?.title || 'Ask a Friend';
    },
    text() {
      return this.config?.text || 'Share this question with a BFF.';
    },
    url() {
      const cfg = this.config;
      const fid = this.flashcard?.id;
      if (!cfg?.url || fid == null || fid === '') {
        return '';
      }
      let u = `${cfg.url}?fid=${fid}`;
      if (cfg.sc) {
        u += `&sc=${cfg.sc}`;
      }
      return u;
    },
  },
};
</script>

<style>

</style>
